<template>
  <div
    class="Overlay Overlay-sup"
    data-action="close-modal"
  >
    <div
      class="ModalBox ModalBox--central Modal--filters sup2"
      :class="modalClass"
    >
      <div class="ModalBox-header d-flex justify-content-between align-items-center p-3">
        <button
          v-if="closeButton"
          class="Fuell-IconButton Fuell-IconButton--no-margin Fuell-IconButton--close"
          @click="close"
        >
          <img
            class="Fuell-IconButton--close-img"
            :src="require('@/assets/img/icons/close.svg')"
            alt="Close"
          />
        </button>
        <div
          class="Tit Tit--modal w-100"
          v-t="{ path: title }"
        ></div>
      </div>
      <div
        class="ModalBox-container position-relative pl-4 pr-4"
        :class="{'pt-4 pb-3': !noPadding, 'mt-5': !noMargin}"
      >
        <div
          class="Fuell-Text text-center"
          v-if="!ignoreDefaultMessage"
        >
          {{ $t(message) }}
        </div>
        <slot
          class="text-center"
          name="additional"
          :extraInfo="extraInfo"
        >
        </slot>
      </div>
      <slot name="content"></slot>
      <div
        class="p-3 d-flex justify-content-center button-container"
        :class="{'mt-5': !message && !extraInfo}"
      >
        <button
          v-if="!hideDismissButton"
          type="button"
          @click="dismiss"
          class="Fuell-Button mx-2 flex-grow-1 flex-shrink-1"
          :class="dismissBtnClass"
        >
          <span
            class="Fuell-Button--label"
            v-t="{ path: dismissText }"
          ></span>
        </button>
        <button
          type="button"
          @click="accept"
          class="Fuell-Button mx-2 flex-grow-1 flex-shrink-1 "
          :disabled="disabledConfirm"
          :class="acceptBtnClass"
        >
          <span
            class="Fuell-Button--label"
            v-t="{ path: acceptText }"
          ></span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ConfirmModal',
  props: {
    id: {
      type: String
    },
    title: {
      type: String,
      default: 'confirm_modal_title'
    },
    message: {
      type: String,
      default: 'confirm_modal_message'
    },
    acceptText: {
      type: String,
      default: 'confirm_modal_accept_button_text'
    },
    dismissText: {
      type: String,
      default: 'confirm_modal_dismiss_button_text'
    },
    modalClass: {
      type: String,
      default: 'ModalBox--400'
    },
    acceptBtnClass: {
      type: String,
      default: 'red'
    },
    dismissBtnClass: {
      type: String,
      default: ''
    },
    hideDismissButton: {
      type: Boolean,
      default: false
    },
    ignoreDefaultMessage: {
      type: Boolean,
      default: false
    },
    extraInfo: {
      type: [Object, String, Number, Boolean]
    },
    disabledConfirm: {
      type: Boolean,
      default: false
    },
    closeButton: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    noMargin: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    accept () {
      this.$emit('accept')
      this.$emit('update:open', false)
    },
    dismiss () {
      this.$emit('dismiss')
      this.$emit('update:open', false)
    },
    close () {
      this.$emit('close')
      this.$emit('update:open', false)
    }
  }
}
</script>
<style scoped>
.Overlay-sup {
  z-index: 10001 !important;
}
.button-container > .Fuell-Button {
  display: flex;
  justify-content: center;
}
.Fuell-Text {
  line-height: 22px;
}
</style>
